/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CopyIcon64Regular = forwardRef('CopyIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.5 4C13.701 4 9 8.701 9 14.5v31C9 51.299 13.701 56 19.5 56h21C46.299 56 51 51.299 51 45.5v-31C51 8.701 46.299 4 40.5 4h-21ZM12 14.5A7.5 7.5 0 0 1 19.5 7h21a7.5 7.5 0 0 1 7.5 7.5v31a7.5 7.5 0 0 1-7.5 7.5h-21a7.5 7.5 0 0 1-7.5-7.5v-31Z" }),
        React.createElement("path", { d: "M58 24.5a1.5 1.5 0 0 0-3 0v23C55 54.404 49.404 60 42.5 60h-20a1.5 1.5 0 0 0 0 3h20C51.06 63 58 56.06 58 47.5v-23Z" })));
});
